module.exports = __webpack_public_path__ + "static/img/fb-cover.8eb041a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/download/fb-cover.png
// module id = 392
// module chunks = 1